module.exports = __webpack_public_path__ + "img/color_mixer_main.77ea927e.jpg";